// import { Meter } from "./base-units";
import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Watt, BtuPerHour } from "./power";
import { DeltaCelsius, DeltaFahrenheit } from "./delta-temperature";
import { Foot } from "./length";
// Thermal conductivity
export var WattPerMeterPerKelvin = UnitDivide.heatCapacityRateByLength("WattPerMeterPerKelvin", UnitDivide.powerByDeltaTemperature("", Watt, DeltaCelsius), BaseUnits.Meter);
export var BtuPerHourPerFeetPerFahrenheit = UnitDivide.heatCapacityRateByLength("BtuPerHourPerFeetPerFahrenheit", UnitDivide.powerByDeltaTemperature("", BtuPerHour, DeltaFahrenheit), Foot);
//# sourceMappingURL=thermal-conductivity.js.map